import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { createElement } from "@wordpress/element";

/**
 * External dependencies
 */
import classnames from 'classnames';
/**
 * WordPress dependencies
 */

import { useRef, useEffect, useState } from '@wordpress/element';
/**
 * Internal dependencies
 */

import Popover from '../popover';

function useObservableState(initialState, onStateChange) {
  var _useState = useState(initialState),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  return [state, function (value) {
    setState(value);

    if (onStateChange) {
      onStateChange(value);
    }
  }];
}

export default function Dropdown(_ref) {
  var _popoverProps$anchorR;

  var renderContent = _ref.renderContent,
      renderToggle = _ref.renderToggle,
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? 'bottom right' : _ref$position,
      className = _ref.className,
      contentClassName = _ref.contentClassName,
      expandOnMobile = _ref.expandOnMobile,
      headerTitle = _ref.headerTitle,
      focusOnMount = _ref.focusOnMount,
      popoverProps = _ref.popoverProps,
      onClose = _ref.onClose,
      onToggle = _ref.onToggle;
  var containerRef = useRef();

  var _useObservableState = useObservableState(false, onToggle),
      _useObservableState2 = _slicedToArray(_useObservableState, 2),
      isOpen = _useObservableState2[0],
      setIsOpen = _useObservableState2[1];

  useEffect(function () {
    return function () {
      if (onToggle) {
        onToggle(false);
      }
    };
  }, []);

  function toggle() {
    setIsOpen(!isOpen);
  }
  /**
   * Closes the dropdown if a focus leaves the dropdown wrapper. This is
   * intentionally distinct from `onClose` since focus loss from the popover
   * is expected to occur when using the Dropdown's toggle button, in which
   * case the correct behavior is to keep the dropdown closed. The same applies
   * in case when focus is moved to the modal dialog.
   */


  function closeIfFocusOutside() {
    var ownerDocument = containerRef.current.ownerDocument;

    if (!containerRef.current.contains(ownerDocument.activeElement) && !ownerDocument.activeElement.closest('[role="dialog"]')) {
      close();
    }
  }

  function close() {
    if (onClose) {
      onClose();
    }

    setIsOpen(false);
  }

  var args = {
    isOpen: isOpen,
    onToggle: toggle,
    onClose: close
  };
  return createElement("div", {
    className: classnames('components-dropdown', className),
    ref: containerRef
  }, renderToggle(args), isOpen && createElement(Popover, _extends({
    position: position,
    onClose: close,
    onFocusOutside: closeIfFocusOutside,
    expandOnMobile: expandOnMobile,
    headerTitle: headerTitle,
    focusOnMount: focusOnMount
  }, popoverProps, {
    anchorRef: (_popoverProps$anchorR = popoverProps === null || popoverProps === void 0 ? void 0 : popoverProps.anchorRef) !== null && _popoverProps$anchorR !== void 0 ? _popoverProps$anchorR : containerRef.current,
    className: classnames('components-dropdown__content', popoverProps ? popoverProps.className : undefined, contentClassName)
  }), renderContent(args)));
}
//# sourceMappingURL=index.js.map